export default __webpack_public_path__ + "static/media/211.f5845cd2.gif";